import { SCENE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: `${SCENE_MNG}/relateSegmentScene`,
  params: null,
  extraParams: {},
  okAction: 'create',
  formatData(data) {
    data.sceneId = this.extraParams?.sceneId
    const relateFeatureArr = data.relateSegmentSceneArr.map(item => {
      return item.id
    })
    data.relateSegmentSceneArr = relateFeatureArr
    return data
  },
  view: {
    title: '关联细分场景',
    labelPosition: 'right',
    content: [
      {
        $id: 'relateSegmentSceneArr',
        label: '关联细分场景',
        $type: 'sky-relation-option',
        actions: {
          nativeOn: {
            click: 'RelationSegmentScene'
          }
        },
        $el: {
          multiple: true
        }
      }
    ]
  }
}
